module.exports = __webpack_public_path__ + "img/ribbon.adac6162.svg";